var _G, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgHomeAreaIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#home-area-icon_svg__clip0_88_2410)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M28.355 15.944L17.144 4.284a.926.926 0 00-1.335 0L4.598 15.944a.7.7 0 00.505 1.185h1.223c.142 0 .257.115.257.257v10.9c0 .142.115.257.257.257h6.47a.257.257 0 00.257-.257v-7.505c0-.142.115-.257.257-.257h5.306c.142 0 .257.115.257.257v7.505c0 .142.115.257.257.257h6.47a.257.257 0 00.256-.257v-10.9c0-.142.115-.257.257-.257h1.224a.7.7 0 00.504-1.185z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "home-area-icon_svg__clip0_88_2410"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0 0h33v33H0z"
  })))));
}

export default SvgHomeAreaIcon;